import React, { useState, createContext, useContext } from 'react';
interface CartContextType {
  isCartOpen: boolean;
  openCart: () => void;
  closeCart: () => void;
}
const CartContext = createContext<CartContextType | undefined>(undefined);
export function CartProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);
  return <CartContext.Provider value={{
    isCartOpen,
    openCart,
    closeCart
  }} data-id="element-60">
      {children}
    </CartContext.Provider>;
}
export function useCart() {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}